export default __webpack_public_path__ + "static/media/concierge.e5a9b459.png";